/**
 * Servicio API para SB Product Collection Campaigns
 * Targeting solo por Products, 1-3 ASINs propios, logo + headline
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const SbProductCollectionAPI = {

    /**
     * Sube archivos: CSV targeting, logo, imagen
     */
    uploadFiles: async function (targetingCSV, logo, customImage, negativeCSV) {
        const formData = new FormData();

        if (targetingCSV) formData.append('targetingCSV', targetingCSV);
        if (logo) formData.append('logo', logo);
        if (customImage) formData.append('customImage', customImage);
        if (negativeCSV) formData.append('negativeCSV', negativeCSV);

        const response = await fetch(`${API_BASE_URL}/sb-product-collection/upload`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error uploading files');
        }

        return await response.json();
    },

    /**
     * Creates a Product Collection campaign
     */
    createCampaign: async function (options) {
        const formData = new FormData();

        formData.append('profileId', options.profileId);
        formData.append('campaignName', options.campaignName);
        formData.append('dailyBudget', options.dailyBudget);
        formData.append('startDate', options.startDate);
        formData.append('endDate', options.endDate || '');
        formData.append('defaultBid', options.defaultBid);
        formData.append('state', options.state);
        formData.append('brandEntityId', options.brandEntityId);
        formData.append('headline', options.headline);
        formData.append('adFormat', 'productCollection');

        // Products
        formData.append('productAsins', JSON.stringify(options.productAsins));
        formData.append('targeting', JSON.stringify(options.targeting));

        // Files
        if (options.logo) formData.append('logo', options.logo);
        if (options.customImage) formData.append('customImage', options.customImage);
        if (options.negatives) formData.append('negatives', JSON.stringify(options.negatives));

        const response = await fetch(`${API_BASE_URL}/sb-product-collection/create`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error creating campaign');
        }

        return await response.json();
    },

    /**
     * Obtiene marcas disponibles
     */
    getBrands: async function (profileId) {
        const response = await fetch(`${API_BASE_URL}/sb-product-collection/brands?profileId=${profileId}`);
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error loading brands');
        }
        return await response.json();
    }
};

export default SbProductCollectionAPI;


